export const FETCH_AVAILABILITY = 'availability/FETCH';
export const FETCH_AVAILABILITY_SUCCESS = 'availability/FETCH_SUCCESS';
export const FETCH_AVAILABILITY_FAIL = 'availability/FETCH_FAIL';

/* eslint-disable */
const AvailabilityReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_AVAILABILITY_SUCCESS:
      if (action.payload.response && action.payload.response.length) {
        let newState = {}
        action.payload.response.forEach(({ response, sku }) => {
          const { available: isAvailable, ...price } = response.data[0];
          newState[sku] = {
            isLoading: false,
            isAvailable,
            isPriceUpdated: true,
            isLoaded: true,
            discountRateCash: price && price.cash && price.cash.discountRateCash,
            discountRate: price && price.discountRate,
            ...(isAvailable && { price }),
          }
        })
        return {
          ...state,
          ...newState,
        };
      }
      break;
    case FETCH_AVAILABILITY_FAIL:
      return {
        ...state,
        [action.payload.sku]: {
          isLoading: false,
          isAvailable: false,
          isPriceUpdated: true,
        },
      };
    default:
      return { ...state };
  }
};

export default AvailabilityReducer;
